<div class="slidecontainer">
  <input type="range" [min]="valueMin" max="100" value="40" class="slider end" id="end"
    [(ngModel)]="valueMax"
    [style.width]="getWidthEnd()">
  <input type="range" min="0" [max]="valueMax" value="20" class="slider start" id="start"
    [(ngModel)]="valueMin"
    [style.width]="getWidthStart()">
</div>
<div> {{valueMin}} - {{valueMax}} </div>
